import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-reach-out-section',
    imports: [],
    templateUrl: './reach-out-section.component.html',
    styleUrl: './reach-out-section.component.less',
})
export class ReachOutSectionComponent {
    constructor(private router: Router) {}

    goContactUs() {
        this.router.navigate(['/main/contact-us']);
    }
}
